<template>
  <pdfShow class="publicity" :pdfUrl="pdfUrl" />
</template>
<script>
import pdfShow from "@/components/pdfShow";

export default {
  name: "publicity",
  components: { pdfShow },
  data() {
    return {
      pdfUrl: `${window.location.origin}${window.location.pathname}RecordPublicity.pdf`,
    };
  },
};
</script>

<style scoped>
.publicity {
  height: 100%;
}
</style>
